import { DesignationService } from './../../_services/designation.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { StaffService } from '../../_services/staff.service';
import { GlobalService } from '../../_services/global.service';
import { AuthService } from '../../_services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs';
import { DepartmentService } from '../../_services/department.service';
import { DivisionService } from '../../_services/division.service';
import { UnitService } from '../../_services/unit.service';
import { PaginationInfo } from '../../_models/pagination-info';
import {
  DashboardFilter,
  InitialDashboardFilter,
} from '../../interfaces/dashboard.interface';

@Component({
  selector: 'iq-central-front-end-staff',
  templateUrl: './staff.component.html',
  styleUrls: ['./staff.component.scss'],
})
export class StaffComponent implements OnInit, OnDestroy {
  staffForm: FormGroup;
  staffs: any[] = [];
  filteredStaffs: any;
  admin: any;
  departments: any[] = [];
  designations: any[] = [];
  divisions: any[] = [];
  units: any[] = [];
  paginationInfo: PaginationInfo;
  destinationUrl: string;
  createPayload: any;
  sub: Subscription = new Subscription();
  staffData: Array<any>;
  totalRecords: any;
  page: any;

  filterQuery: DashboardFilter = { ...InitialDashboardFilter };

  @ViewChild('dismiss') dismiss: any;

  constructor(
    private fb: FormBuilder,
    private _staffService: StaffService,
    private _auth: AuthService,
    private _global: GlobalService,
    private _departmentService: DepartmentService,
    private _divisionService: DivisionService,
    private _designation: DesignationService,
    private _unitService: UnitService,
    private _activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.staffData = new Array<any>();
  }

  ngOnInit() {
    this.getResolvedData();
    this.getAllDepartments();
    this.getAllDesignations();
    this.initStaffForm();
  }

  getResolvedData() {
    this.sub.add(
      this._activatedRoute.data.subscribe((response) => {
        this.staffs = this.filteredStaffs =
          response['resolvedData'].staffs['responseResult'].users;
        this.paginationInfo =
          response['resolvedData'].staffs['responseResult'].paginationInfo;
        console.log(this.staffs);
      })
    );
  }

  getAllDepartments() {
    this._departmentService.getAllDepartments(this.filterQuery).subscribe({
      next: (response) => {
        this.departments = response['responseResult'];
      },
    });
  }
  getAllDesignations() {
    this._designation.getAllDesignations().subscribe({
      next: (response) => {
        this.designations = response['responseResult'];
      },
    });
  }
  getAllDivisionsByDepartment(id) {
    this._divisionService.getAllDivisionsByDepartment(id).subscribe({
      next: (response) => {
        this.divisions = response['responseResult'];
      },
    });
  }

  getAllUnitsByDivision(id) {
    this._unitService.getAllUnitsByDivision(id).subscribe({
      next: (response) => {
        this.units = response['responseResult'];
      },
    });
  }

  ifAdmin() {
    console.log(this.staffForm.value);
  }

  initStaffForm() {
    this.staffForm = this.fb.group({
      fullName: ['', [Validators.required]],
      employmentNumber: ['', [Validators.required]],
      username: ['', [Validators.required, Validators.email]],
      departmentId: ['', [Validators.required]],
      divisionId: ['', [Validators.required]],
      designationId: ['', [Validators.required]],
      unitId: ['', [Validators.required]],
      isAdmin: [''],
    });
  }

  navigatePage(page) {
    this._global.showSpinner();
    this._staffService.getAllEnterpriseUsers(page, 5).subscribe({
      next: (res) => {
        this._global.hideSpinner();
        this.staffs = res['responseResult'].users;
        this.paginationInfo = res['responseResult'].paginationInfo;
      },
    });
  }

  onSubmit() {
    console.log(this.staffForm);
    if (this.staffForm.invalid) {
      this.staffForm.markAllAsTouched();
      return;
    }

    this._global.showSpinner();
    console.log(this.staffForm.value);
    this.sub.add(
      this._staffService.createEnterpriseUser(this.staffForm.value).subscribe({
        next: (response) => {
          this.dismiss.nativeElement.click();
          this.getResolvedData();
          this._global.hideSpinnerWithMessage(response, 'success');
          this.staffData = this.staffs;
          this.totalRecords = this.staffs.length;
          this.staffForm.reset();
        },
      })
    );
  }

  filter(query: string) {
    this.staffs = query
      ? this.filteredStaffs.filter((c) =>
          c.user.fullName.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredStaffs;
  }

  sortByName() {
    this.staffs.sort((a, b) => {
      if (a.user.fullName < b.user.fullName) return -1;
      else if (a.user.fullName > b.user.fullName) return 1;
      else return 0;
    });
  }

  sortByDept() {
    this.staffs.sort((a, b) => {
      if (a.department.name < b.department.name) return -1;
      else if (a.department.name > b.department.name) return 1;
      else return 0;
    });
  }

  sortByUnit() {
    this.staffs.sort((a, b) => {
      if (a.unit.name < b.unit.name) return -1;
      else if (a.unit.name > b.unit.name) return 1;
      else return 0;
    });
  }
  sortByDesignation() {
    this.staffs.sort((a, b) => {
      if (a.designation.name < b.designation.name) return -1;
      else if (a.designation.name > b.designation.name) return 1;
      else return 0;
    });
  }
  sortByDivision() {
    this.staffs.sort((a, b) => {
      if (a.division.name < b.division.name) return -1;
      else if (a.division.name > b.division.name) return 1;
      else return 0;
    });
  }
  Admin() {
    this.staffs.sort((a, b) => {
      if ((a.isAdmin == true < b.isAdmin) == false) return -1;
      else if ((a.isAdmin == true > b.isAdmin) == false) return 1;
      else return 0;
    });
  }

  sortByDate() {
    this.staffs.sort(
      (a, b) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
